module.exports = __webpack_public_path__ + "static/media/t-mobile_logo.5caf6afb.png";